"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var topLeft = function (size) { return "border-top-left-radius: " + size + ";"; };
var topRight = function (size) { return "border-top-right-radius: " + size + ";"; };
var bottomLeft = function (size) { return "border-bottom-left-radius: " + size + ";"; };
var bottomRight = function (size) { return "border-bottom-right-radius: " + size + ";"; };
var radiusMap = {
    top: function (size) { return "\n    " + topLeft(size) + "\n    " + topRight(size) + "\n  "; },
    left: function (size) { return "\n    " + topLeft(size) + "\n    " + bottomLeft(size) + "\n  "; },
    bottom: function (size) { return "\n    " + bottomLeft(size) + "\n    " + bottomRight(size) + "\n  "; },
    right: function (size) { return "\n    " + topRight(size) + "\n    " + bottomRight(size) + "\n  "; },
    'top-left': topLeft,
    'top-right': topRight,
    'bottom-left': bottomLeft,
    'bottom-right': bottomRight,
};
var getRadius = function (defaultSizes, round) {
    if (round === true) {
        return defaultSizes[1];
    }
    if (typeof round === 'number') {
        return defaultSizes[round];
    }
    return '';
};
exports.default = (function (_a) {
    var defaultSizes = _a.theme.sizes.default, round = _a.round;
    if (!round) {
        return '';
    }
    var value = getRadius(defaultSizes, round);
    if (value) {
        return "border-radius: " + value + ";";
    }
    if (typeof round === 'object') {
        var side = round.side, _b = round.size, size = _b === void 0 ? 1 : _b;
        return side && side in radiusMap ? radiusMap[side](defaultSizes[size]) : '';
    }
});
